import { apiSlice } from "../../apiSlice";

/**
 * Slice para el dashboard de Doc. Transporte sin DO Asociado
 */
export const doctradoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicTransportSinDo: builder.query({
      query: () => ({
        url: "/Dashboax/Graphics/Doctrado",
        method: "GET",
        headers: { Modulecima: "dashboax" },
      }),
    }),
  }),
});

export const { useGetDataGraphicTransportSinDoQuery } = doctradoApiSlice;
